<template>
  <a-modal v-model="visible" width="1100px" :mask-closable="false" title="新建货品" :footer="null" centered @cancel="onhidden">
    <div class="chooseGoods"></div>
    <a-form-model ref="addGoodsModel" :model="form" :rules="rules" layout="inline">
      <a-form-model-item
        ref="skuName"
        v-bind="colWidth"
        label="货品名称"
        prop="skuName"
      >
        <a-input v-model="form.skuName" placeholder="请输入,最多30个字符" />
      </a-form-model-item>
      <a-form-model-item
        ref="level"
        v-bind="colWidth"
        label="货品三级分类"
        prop="level"
      >
        <a-cascader
          v-model="form.level"
          allow-clear
          :options="levelOptions"
          :field-names="{
            label: 'name',
            value: 'name',
            children: 'children'
          }"
          placeholder="请选择货品三级分类"
          @change="changeLevel"
        />
      </a-form-model-item>
      <a-form-model-item
        ref="skuCode"
        v-bind="colWidth"
        label="货主货品编码"
        prop="skuCode"
      >
        <a-input v-model="form.skuCode" placeholder="请输入,最多30个字符，不填写系统将自动生成" />
      </a-form-model-item>
      <a-form-model-item
        ref="norms"
        v-bind="colWidth"
        label="货品基础规格"
        prop="norms"
      >
        <a-input v-model="form.norms" placeholder="请输入,最多20个字符" />
      </a-form-model-item>
      <a-form-model-item
        ref="unit"
        v-bind="colWidth"
        label="货品整单位"
        prop="unit"
      >
        <a-input v-model="form.unit" placeholder="箱、袋、个、件等，不填写默认为件" />
      </a-form-model-item>
      <a-form-model-item
        ref="weight"
        v-bind="colWidth"
        label="整单位重量"
        prop="weight"
      >
        <InputNumber v-model="form.weight" suffix="kg" :max="999999.999" placeholder="请输入，仅支持数字" />
      </a-form-model-item>
      <a-form-model-item
        ref="volume"
        v-bind="colWidth"
        label="整单位体积"
        prop="volume"
      >
        <InputNumber v-model="form.volume" suffix="M³" :max="999999.999" placeholder="请输入，仅支持数字" />
      </a-form-model-item>
      <a-form-model-item
        ref="temperatureType"
        v-bind="colWidth"
        label="货品温度类型"
        prop="temperatureType"
      >
        <a-select
          v-model="form.temperatureType"
          placeholder="请选择货品温度类型"
          :get-popup-container="triggerNode => triggerNode.parentNode"
        >
          <a-select-option
            v-for="temp in TEMPERATURETYPE"
            :key="temp.value"
            :value="temp.value"
          >{{temp.label}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        ref="temperatureZone"
        v-bind="colWidth"
        label="温区"
        prop="temperatureZone"
      >
        <a-select
          v-model="form.temperatureZone"
          placeholder="请选择温区"
          :get-popup-container="triggerNode => triggerNode.parentNode"
          @change="changeTempratureZone"
        >
          <a-select-option
            v-for="temp in temperatureOption"
            :key="temp.value"
            :value="temp.value"
          >{{temp.label}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-bind="colWidth"
        label="自定义温区"
        class="temperature-code"
      >
        <a-input-number
          v-model="form.minTemperature"
          :disabled="disableTemperature"
          :min="temperatureRule.min"
          :max="temperatureRule.max"
          :precision="0"
          placeholder="请输入，仅支持整数"
        />
        <span class="separator">-</span>
        <a-input-number
          v-model="form.maxTemperature"
          :min="temperatureRule.min"
          :max="temperatureRule.max"
          :disabled="disableTemperature"
          :precision="0"
          placeholder="请输入，仅支持整数"
        />
      </a-form-model-item>
      <a-form-model-item
        ref="goodsPrice"
        v-bind="colWidth"
        label="货品单件含税价"
        prop="goodsPrice"
      >
        <InputNumber
          v-model="form.goodsPrice"
          suffix="元"
          :precision="2"
          :max="999999999.99"
          placeholder="请输入，仅支持数字"
        />
      </a-form-model-item>
    </a-form-model>

    <a-row class="btnBox">
      <a-col :span="8" :offset="16">
        <a-button class="goodsSelectStyle" @click="onhidden">取消</a-button>
        <a-button v-track-click="{ trackName: '新建货品-提交' }" class="goodsSelectStyle" type="primary" @click="onUpdate">提交</a-button>
        <a-button v-track-click="{ trackName: '新建货品-提交并继续新建' }" class="goodsSelectStyle" type="primary" @click="onContinue">提交并继续新建</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import InputNumber from "@/components/form/InputNumber.vue";
import { createSku } from "../api";

const TEMPERATURES = [
  {
    value: "常温",
    label: "常温",
  },
  {
    value: "冷藏",
    label: "冷藏",
  },
  {
    value: "冷冻",
    label: "冷冻",
  },
  {
    value: "自定义温区",
    label: "自定义温区",
  },
];

const TEMPERATURETYPE = [
  {
    value: 'NORMAL',
    label: '常温品'
  },
  {
    value: 'COLD',
    label: '冷藏品'
  },
  {
    value: 'FROZEN',
    label: '冷冻品'
  },
]
const TEMPERATURE = {
  '常温': [],
  '冷藏': [0, 9],
  '冷冻': [-99, -18]
};

export default {
  name: "AddGoods",
  components: {
    InputNumber,
  },
  props: {},
  inject: ['order'],
  data() {
    return {
      visible: false,
      colWidth:{
        labelCol: {span: 5},
        wrapperCol: {span: 19}
      },
      form: {
        skuCode: "",
        skuName: "",
        norms: "",
        unit: "",
        weight: "",
        volume: "",
        goodsPrice: "",
        minTemperature: "",
        maxTemperature: '',
        temperatureZone: undefined,
      },
      rules: {
        skuCode: [{ max: 30, message: "长度不超过30字符", trigger: "change" }],
        skuName: [
          { required: true, message: "请输入货品名称", trigger: "change" },
          { max: 30, message: "长度不超过30字符", trigger: "change" },
        ],
        level: [
          { required: true, message: "请选择三级分类", trigger: "change" },
        ],
        norms: [
          { required: true, message: "请输入规格", trigger: "change" },
          { max: 30, message: "长度不超过30字符", trigger: "change" },
        ],
        unit: [{ max: 4, message: "长度不超过4字符", trigger: "change" }],
        weight: [
          { required: true, message: "请输入单件重量", trigger: "change" },
        ],
        volume: [
          { required: true, message: "请输入单件体积", trigger: "change" },
        ],
        temperatureZone: [
          { required: true, message: "请选择温区", trigger: "change" },
        ],
      },
      TEMPERATURES,
      levelOptions: [],
      levelParams: null,
      temperatureOption: [],
      disableTemperature: true,
      temperatureRule: {},
      TEMPERATURETYPE,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    changeLevel(val) {
      this.form.temperatureZone = undefined
      this.form.minTemperature = ""
      this.form.maxTemperature = ""
      if (val?.length) {
        this.$set(this.form, 'ext', {
          goodsLevel1: val[0],
          goodsLevel2: val[1],
          goodsLevel3: val[2],
        })
      }
      if(!val || !val.length) {
        this.temperatureOption = []
      } else if (this.levelParams) {
        // 合同卡控时，合同卡控的温区选项
        const option = this.levelParams[val[0]][val[1]][val[2]]
        const temperatureList = []
        option.forEach(item => {
          temperatureList.push({
            ...item,
            value: item.name,
            label: item.name,
          })
        })
        this.temperatureOption = temperatureList
      } else {
        // 合同未卡控时，可选择“常温/冷藏/冷冻/自定义温区”
        this.temperatureOption = TEMPERATURES
      }
    },
    changeTempratureZone(val) {
      let minTemperature = ''
      let maxTemperature = ''
      let min = -99;
      let max = 99;
      if (TEMPERATURE[val]) {
        this.disableTemperature = true;
        [minTemperature, maxTemperature] = TEMPERATURE[val]
      } else {
        // 自定义温区默认值
        const isCustom = this.temperatureOption.find(item => item.name === '自定义温区')
        if (isCustom) {
          minTemperature = isCustom.minInterval || undefined
          maxTemperature = isCustom.maxInterval || undefined
          this.disableTemperature = !isCustom.canEdit
          min = isCustom.minInterval ? Number(isCustom.minInterval) : undefined
          max = isCustom.maxInterval ? Number(isCustom.maxInterval) : undefined
        } else {
          this.disableTemperature = false;
        }
      }
      this.$set(this.form, 'minTemperature', minTemperature)
      this.$set(this.form, 'maxTemperature', maxTemperature)
      this.temperatureRule = {
        min,
        max,
      }
    },
    onhidden() {
      this.visible = false;
      this.$emit('create')
    },
    show() {
      this.visible = true;
      this.form = {
        skuCode: "",
        skuName: "",
        norms: "",
        unit: "",
        weight: "",
        volume: "",
        goodsPrice: "",
        minTemperature: "",
        maxTemperature: '',
        temperatureZone: undefined,
      };
      this.levelOptions = this.order.levelOptions
      this.levelParams = this.order.levelParams
    },
    validateTemperature() {
      const {temperatureZone, minTemperature,maxTemperature} = this.form
      if (temperatureZone !== '常温' && ((!minTemperature && minTemperature.toString()!=='0') || (!maxTemperature && maxTemperature.toString()!=='0'))){
        this.$message.warning('请填写温度区间')
        return false
      }
      if (Number(minTemperature) > Number(maxTemperature)) {
        this.$message.warning('自定义温区最低温不能大于最高温')
        return false
      }
      return true
    },
    async onUpdate() {
      await this.$refs.addGoodsModel.validate();
      const canSubmit = this.validateTemperature();
      if (!canSubmit) {
        return
      }
      await createSku(this.form);
      this.$message.success("操作成功");
      this.onhidden()
    },
    async onContinue() {
      await this.$refs.addGoodsModel.validate();
      const canSubmit = this.validateTemperature();
      if (!canSubmit) {
        return
      }
      await createSku(this.form);
      this.$message.success("操作成功");
      this.show()
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  width: calc(50% - 16px);
  margin-bottom: 24px;
}
/deep/ .ant-form-explain {
  position: absolute;
}
.btnBox {
  padding-right: 16px;
  text-align: right;
  button {
    margin-left: 15px;
  }
}
.temperature-radio {
  line-height: 40px;
}
.temperature-code {
  /deep/ .ant-form-item-children {
    display: flex;
    align-items: center;
    .ant-input-number {
      flex: 1;
      .ant-input-number-handler-wrap {
        display: none;
      }
    }
  }
  .separator {
    margin: 0 4px;
  }
}
</style>